
import React from "react";
import ActiveRolesDashFilter from "./components/content/ActiveRolesDashFilter";
import CaseStatusDashFilter from "./components/content/CaseStatusDashFilter";
import MedicalStatusDashFilter from "./components/content/MedicalStatusDashFilter";
import OtherPagesDashFilter from "./components/content/OtherPagesDashFilter";
import DashboardCard from "./components/DashboardCard";
import DashboardCardFilters from "./components/DashboardCard/DashboardCardFilters";
 
 
export default function DashboardHeaderFilters({
  filters,
  updateFilter,
  userStatData,
  medicalStatusData,
  getFilterUIState,
  setFilterUIState
}) {
 
  return (
    <div id="Dashboard" data-testid="Dashboard">
      <div id="Dashboard-Content">
        <div id="Dashboard-Filters">
          <DashboardCardFilters>
            <DashboardCard title={"Active Roles"} icon='his-person-check'>
              <ActiveRolesDashFilter
                roleCounts={userStatData.roleCounts}
                totalCases={userStatData.totalCases}
                withRoleAssignmentCount={userStatData.withRoleAssignmentCount}
                withoutRoleAssignmentCount={
                  userStatData.withoutRoleAssignmentCount
                }
              />
            </DashboardCard>
            <DashboardCard title={"Case Status"} icon='his-recent-documents'>
              <CaseStatusDashFilter
                caseStatusCounts={userStatData.caseStatusCounts}
                filters={filters}
                updateFilter={updateFilter}
                getFilterUIState={getFilterUIState}
                setFilterUIState={setFilterUIState}
              />
            </DashboardCard>
            <DashboardCard title={"Medical Status"} icon='his-handshake-heart'>
              <MedicalStatusDashFilter
                medicalStatusData={medicalStatusData}
                filters={filters}
                updateFilter={updateFilter}
                getFilterUIState={getFilterUIState}
                setFilterUIState={setFilterUIState}
              />
            </DashboardCard>
            <DashboardCard title={"Other Pages"} icon='his-layers'>
              <OtherPagesDashFilter />
            </DashboardCard>
          </DashboardCardFilters>
        </div>
      </div>
    </div>
  );
}
